import React from 'react';
import { format } from 'date-fns';
import { DatePickerButton } from './DatePickerButton';

export interface DateValuesSectionProps {
  selectedValues: string[];
  onValueChange: (value: string) => void;
  validationErrors?: string[];
}

/**
 * DateValuesSection - Date picker for date-based filters
 * Used for DATE column types with INCLUDES/EXCLUDES operators
 * Values are stored as ISO date-time strings (YYYY-MM-DDTHH:mm:ss)
 */
export const DateValuesSection: React.FC<DateValuesSectionProps> = ({
  selectedValues,
  onValueChange,
  validationErrors = [],
}) => {
  const errorMessage = validationErrors.find(Boolean);
  // Parse the first selected value as a date, or default to undefined
  const selectedDate = selectedValues[0]
    ? new Date(selectedValues[0])
    : undefined;

  // A day-click stages the value into the draft and closes only the calendar
  // popover (handled by the uncontrolled DatePickerButton). The filter is
  // committed solely via the Apply button.
  const handleDateSelect = (date: Date | undefined): void => {
    if (!date) {
      return;
    }
    onValueChange(format(date, "yyyy-MM-dd'T'HH:mm:ss"));
  };

  // Time edits stage into the draft only; Apply commits.
  const handleTimeChange = (date: Date): void => {
    onValueChange(format(date, "yyyy-MM-dd'T'HH:mm:ss"));
  };

  return (
    <div className="flex flex-col gap-2 p-4">
      <DatePickerButton
        selectedDate={selectedDate}
        onDateSelect={handleDateSelect}
        onTimeChange={handleTimeChange}
        placeholder="Select date"
        showTime
      />
      {errorMessage && (
        <div className="text-xs text-destructive">{errorMessage}</div>
      )}
    </div>
  );
};
